import React from "react";
import { twMerge } from "tailwind-merge";

/**
 * CSS three-dot bounce loader.
 * @param {"onDark"|"onLight"} tone — onDark → light dots; onLight → dark dots
 */
export default function ThreeDotLoader({
  className = "",
  alt = "Loading",
  tone = "onDark",
}) {
  return (
    <span
      className={twMerge(
        "ui-three-dot-loader",
        tone === "onLight" ? "ui-three-dot-loader--on-light" : "ui-three-dot-loader--on-dark",
        className,
      )}
      role="status"
      aria-label={alt}
    >
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </span>
  );
}
